import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_sms_message",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "smsMessageModalRef"
}
const _hoisted_2 = { class: "modal-dialog mw-550px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header justify-content-end border-0 pb-0" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body pt-0 pb-15 px-5 px-xl-10" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "w-50" }
const _hoisted_10 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-start" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bold d-block fs-8" }, "SMS Reminder"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold fs-8" }, "Send a default or custom text message ")
  ])
], -1)
const _hoisted_12 = {
  class: "btn btn-outline btn-outline-dashed btn-light-primary btn-active-light-primary p-4 d-flex align-items-center",
  style: {"height":"102px"},
  for: "kt_radio_buttons_2_option_2"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3x me-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bold d-block fs-6" }, "SMS"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 fw-normal fs-6" }, "Friendly reminder, your documents are due soon!")
], -1)
const _hoisted_15 = {
  key: 1,
  class: "d-flex flex-column mb-2 fv-row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-start" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bold d-block fs-8" }, "Custom SMS"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold fs-8" }, "Send a default or custom text message ")
  ])
], -1)
const _hoisted_17 = {
  class: "btn btn-outline btn-outline-dashed btn-light-primary btn-active-light-primary p-4 d-flex align-items-center",
  style: {"height":"102px"},
  for: "kt_radio_buttons_2_option_2"
}
const _hoisted_18 = { class: "svg-icon svg-icon-3x me-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semibold text-start" }, null, -1)
const _hoisted_20 = { class: "row mt-8" }
const _hoisted_21 = { class: "col-sm d-flex flex-column mb-8 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-7 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Name"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Only one unique email address can be used per user."
  })
], -1)
const _hoisted_23 = { class: "col-sm d-flex flex-column mb-8 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-7 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Phone")
], -1)
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = {
  type: "submit",
  ref: "submitButtonRef",
  class: "btn btn-lg btn-primary"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Send", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            id: "add_user_modal_form",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.targetData,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_switch, {
                    id: "kt_horizontal_search_advanced_link",
                    modelValue: _ctx.custom,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.custom) = $event)),
                    inactive: "",
                    size: "small",
                    "data-bs-toggle": "collapse",
                    href: "#kt_advanced_search_form3"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                (_ctx.custom === false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
                        ]),
                        _hoisted_14
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
                        ]),
                        _hoisted_19,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.targetData.textarea,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.textarea) = $event)),
                          rows: 3,
                          type: "textarea",
                          placeholder: "Please input",
                          value: _ctx.targetData.textarea
                        }, null, 8, ["modelValue", "value"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_el_form_item, { prop: "adminfullname" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.targetData.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.name) = $event)),
                        placeholder: _ctx.iboUserDetails.adminfullname,
                        value: _ctx.iboUserDetails.adminfullname,
                        name: "name"
                      }, null, 8, ["modelValue", "placeholder", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_el_form_item, { prop: "phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.targetData.phone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.phone) = $event)),
                        placeholder: _ctx.iboUserDetails.adminphone,
                        value: _ctx.iboUserDetails.adminphone,
                        name: "phone"
                      }, null, 8, ["modelValue", "placeholder", "value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", _hoisted_26, _hoisted_29, 512)
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 512))
}